export default {
  questions: {},
  exam_applications: {},
  board_sections: {},
  materials: {},
  essay_replies: {},
  contents: {},
  texts: {},
  images: {},
  videos: {},
  corrections: {},
  correction_scores: {},
  correction_criterias: {},
  annotations: {},
  knowledges: {},
  exams: {},
  exam_questions: {},
  exam_groups_exams: {},
  exam_groups: {},
  exam_modes: {},
};
